import { UserProfile } from '@atlassiansox/asc-stargate';

import { useStargateClient } from './use-stargate-client';
import { AsyncResult, useAsync } from './use-async';

export function useMe(): AsyncResult<UserProfile | null> {
  const stargateClient = useStargateClient();

  return useAsync(() => stargateClient.me({}), []);
}
